module.exports = __webpack_public_path__ + "img/schedule.b042745a.png";